'use client'
import * as React from 'react'

import { OpenAStoreModal } from '../_components/open-a-store-modal'

interface ModalContextType {
  isOpenStoreModalOpen: boolean
  openOpenStoreModal: () => void
  closeOpenStoreModal: () => void
}

const ModalContext = React.createContext<ModalContextType | undefined>(undefined)

export function ModalProvider({ children }: { children: React.ReactNode }) {
  const [isOpenStoreModalOpen, setIsOpenStoreModalOpen] = React.useState(false)

  const openOpenStoreModal = () => setIsOpenStoreModalOpen(true)
  const closeOpenStoreModal = () => setIsOpenStoreModalOpen(false)

  return (
    <ModalContext.Provider
      value={{
        isOpenStoreModalOpen,
        openOpenStoreModal,
        closeOpenStoreModal,
      }}
    >
      {children}
      {isOpenStoreModalOpen ? <OpenAStoreModal /> : null}
    </ModalContext.Provider>
  )
}

export function useModalContext() {
  const context = React.useContext(ModalContext)
  if (context === undefined) {
    throw new Error('useModalContext must be used within a ModalProvider')
  }
  return context
}
